import * as React from 'react';
import { Button } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { EventFeedback, Event, FeedbackForm, FeedbackFormQuestion } from 'cb-model';
import {
  Display,
  IsAllowed,
  List,
  NavIconContainer,
  PageTitle,
  QueryMulti,
  QuerySingle,
  Section,
} from 'gossamer-front-end';
import { getFilter } from 'gossamer-unified';
import { FeedbackDateRangeExport } from './FeedbackDateRangeExport';

export const FeedbackFormDisplay = (): React.JSX.Element => {
  const params = useParams();
  return (
    <>
      <NavIconContainer entityId={FeedbackForm.id} />
      <PageTitle
        verb="Display"
        entity={FeedbackForm}
        keyValue={params.key}
        subtitle="Details relating to a Feedback Form"
      />
      <Section>
        <QuerySingle entity={FeedbackForm} keyValue={params.key} render={Display} />
        <IsAllowed entity={FeedbackForm} action="update">
          <Link to={`/admin/feedback-form/update/${params.key}`}>
            <Button size="sm" variant="primary">
              Update
            </Button>
          </Link>
        </IsAllowed>
      </Section>
      <Section title="Questions">
        <QueryMulti
          entity={FeedbackFormQuestion}
          alterEntity={(localEntity: typeof FeedbackFormQuestion) => {
            localEntity.fields.feedback_form_id.listColumn = false;
          }}
          queryOptions={{
            where: {
              and: [getFilter('feedback_form_id', 'eq', params.key)],
            },
            order: [['seq', 'ASC']],
          }}
          render={List}
        />
      </Section>

      <Section title="Feedback Submitted" subtitle="using this Feedback Form">
        <QueryMulti
          entity={EventFeedback}
          alterEntity={(localEntity: typeof EventFeedback) => {
            localEntity.fields.feedback_form_id.listColumn = false;
          }}
          queryOptions={{
            where: {
              and: [getFilter('feedback_form_id', 'eq', params.key)],
            },
            order: [['created_at', 'DESC']],
          }}
          render={List}
        />
      </Section>

      <Section title="Export Feedback">
        <FeedbackDateRangeExport endpointPath={`/main/feedback/export/template/${encodeURIComponent(params.key)}`} />
      </Section>

      <Section title="Events" subtitle="using this Feedback Form">
        <QueryMulti
          entity={Event}
          alterEntity={(localEntity: typeof Event) => {
            localEntity.fields.feedback_form_id.listColumn = false;
          }}
          queryOptions={{
            where: {
              and: [getFilter('feedback_form_id', 'eq', params.key)],
            },
          }}
          render={List}
        />
      </Section>
    </>
  );
};
